import React, { useState } from 'react';
import { Tag, Tooltip, Modal, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { FrownOutlined, MehOutlined, SmileOutlined } from '@ant-design/icons';
import { authFetch } from '../../../../../common/request/authFetch';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { EditLabelModal } from './drawer/EditLabelModal';

export const Label = (props: { label: any, reviewId: string, light?: boolean, showCategory?: boolean, onChange: any }) => {

    const light = props.light ?? false;
    const showCategory = props.showCategory ?? false;
    const [editLabelModal, setEditLabelModal] = useState<boolean>(false);
    
    return (
        <>
            <Tag 
                onClick={() => setEditLabelModal(!light)} 
                color = {light ? 'transparent' : 'white' }
                style={{ 
                    margin: light? '0px 5px' : '5px', 
                    border: `solid .5px ${light? 'transparent' : LABEL_COLOR[props.label.sentiment]}`,
                    cursor: 'pointer' 
                }}>
                <Tooltip title={showCategory ? undefined : <>Categoría: "<b>{props.label.category}</b>"</>}>
                    <b style={{ 
                        color: LABEL_COLOR[props.label.sentiment], 
                        fontWeight: light ? 'normal' : 'bold',                
                        display: 'flex', 
                        alignItems: 'center', 
                        fontSize: '15px',
                        gap: 6,
                    }}>
                        {SENTIMENT_ICONS[props.label.sentiment]} 
                        <span style={{ fontSize: '12px', marginLeft: '2px' }}>
                            {props.label.label}
                        </span>
                        {showCategory && props.label.category && (
                            <span style={{
                                fontSize: 10,
                                fontWeight: 500,
                                color: '#94a3b8',
                                letterSpacing: '0.02em',
                                borderLeft: '1px solid #e2e8f0',
                                paddingLeft: 6,
                                marginLeft: 2,
                                lineHeight: 1.2,
                            }}>
                                {props.label.category}
                            </span>
                        )}
                    </b>
                </Tooltip>
            </Tag>
            {editLabelModal && <EditLabelModal reviewId={props.reviewId} label={props.label} onChange={() => {setEditLabelModal(false); props.onChange()}} onFinish={() => {setEditLabelModal(false)}}/>}
        </>
    );
};

export const LabelView = (props: { label: any, light?: boolean }) => {

    const light = props.light ?? false;    
    
    return (
        <>
            <Tag                 
                color = {light ? 'transparent' : 'white' }
                style={{ 
                    margin: light? '0px 5px' : '5px', 
                    border: `solid .5px ${light? 'transparent' : LABEL_COLOR[props.label.sentiment]}`,
                    cursor: light ? 'pointer' : 'pointer' 
                }}>
                <Tooltip title={<>Categoría: "<b>{props.label.category}</b>"</>}>
                    <b style={{ 
                        color: LABEL_COLOR[props.label.sentiment], 
                        display: 'flex', 
                        alignItems: 'center', 
                        fontSize: '15px' 
                    }}>
                        {SENTIMENT_ICONS[props.label.sentiment]} 
                        <span style={{ fontSize: '12px', marginLeft: '2px' }}>
                            {props.label.label}
                        </span>
                    </b>
                </Tooltip>
            </Tag>
        </>
    );
};

export const LABEL_COLOR: any = {
    POSITIVE: "DarkCyan",      
    NEUTRAL: "DarkOrange",  
    NEGATIVE: "Crimson"    
}

export const STAR_COLOR: any = {
    "1": "Crimson",  
    "2": "Crimson",  
    "3": "Crimson",  
    "4": "DarkCyan", 
    "5": "DarkCyan"
}

export const SENTIMENT_ICONS: any = {
    POSITIVE: <SmileOutlined style={{padding:'0px 4px', color:LABEL_COLOR['POSITIVE']}}/>,
    NEUTRAL: <MehOutlined style={{padding:'0px 4px', color:LABEL_COLOR['NEUTRAL']}}/>,
    NEGATIVE: <FrownOutlined style={{padding:'0px 4px', color:LABEL_COLOR['NEGATIVE']}}/>
  };